import React from "react";
import { Link } from "react-router-dom";

const BringCaretoYour = () => {

    return (
        <section className="" data-id="b5eea9e" data-element_type="section" data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;}" style={{ width: '100%', left: '0px', paddingTop: '50px' }}>
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f6b20a1" data-id="f6b20a1" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-4fb7241 elementor-widget elementor-widget-dc_element_about_us" data-id="4fb7241" data-element_type="widget" data-widget_type="dc_element_about_us.default">
                            <div className="elementor-widget-container">
                                <div className="sc-about-us dc-haslayout dc-sectionbg dynamic-secton-771097">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-6 col-sm-6 col-md-6 col-lg-6 align-self-center">
                                                <div className="dc-bringcarecontent">
                                                    <div className="dc-sectionhead dc-sectionheadvtwo">
                                                        <div className="dc-sectiontitle">
                                                            <h2 className="doctor-home-section-title">
                                                                Bring Care to Your													<span>Home With One Click</span>												</h2>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>Experience hassle-free healthcare from the comfort of your home. With just one click, Meddylist.com connects you to trusted medical professionals, enabling you to book appointments, consult doctors online, and access essential healthcare services. Whether it's expert advice, medication delivery, or home healthcare solutions, we ensure your well-being is just a click away.</p>
                                                        </div>
                                                    </div>
                                                    <div className="dc-btnarea">
                                                        <Link to="/about-us" className="dc-btn">About Us</Link>											<Link to="/contact-us" className="dc-btn dc-btnactive">Contact</Link>										</div>
                                                </div>
                                            </div>
                                            <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                                <div className="dc-bringimg-holder">
                                                    <figure className="dc-doccareimg">
                                                        <img decoding="async" width="" height="" src="//css.meddylist.com//wp-content/uploads/2019/08/img-01-2.png" alt="Greetings &amp; Welcome" />																					<figcaption>
                                                            <div className="dc-doccarecontent">
                                                                <h3><em>Greetings &amp; Welcome</em>Dr. Tyrone Grindle</h3>
                                                            </div>
                                                        </figcaption>
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BringCaretoYour;
